export default __webpack_public_path__ + "static/media/offer-vertical-chocolate.83a1b8b3.png";